"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardContent.default;
  }
});

var _CardContent = _interopRequireDefault(require("./CardContent"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/CardContent/index.js
// module id = 245
// module chunks = 0